import lozad from "lozad";
import Swiper, { Navigation, Pagination } from "swiper";
import { header } from "../index/scripts/header";
import { tablePricing } from "../../js/tablePricing";
import { indicatorSlide } from "../index/scripts/helper";
$(document).ready(function () {
	header.init();
	tablePricing();
	indicatorSlide();
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
